import type { ReactNode } from 'react';
import { StyleSheet, View, type StyleProp, type ViewStyle } from 'react-native';
import { NativeSheetFooter } from '../common/NativeSheetLayout';
import { useJourneyPalette } from './journey-theme';

/**
 * Sticky action area under a journey screen (design `.product-footer`):
 * hairline top border, 22pt side padding, 8pt gap, safe-area bottom.
 */
export function JourneyFooter({
  children,
  style,
}: {
  children: ReactNode;
  style?: StyleProp<ViewStyle>;
}) {
  const palette = useJourneyPalette();
  return (
    <NativeSheetFooter
      style={[
        styles.footer,
        { backgroundColor: palette.bg, borderTopColor: palette.line },
        style,
      ]}
    >
      <View style={styles.stack}>{children}</View>
    </NativeSheetFooter>
  );
}

const styles = StyleSheet.create({
  footer: { paddingHorizontal: 22, paddingTop: 12 },
  stack: { gap: 8 },
});
